class Config {
    public apiUrl;
    public apiUrlV2;
    public baseUrl;
    public barcodeBaseUrl;
    public version;
    public crFormat = 'minimal';
    public wsUrl;
    public tokenType = 'webapp_token';

    constructor() {
        this.apiUrl = document.location.protocol + '//' + document.location.host + '/api/';
        this.apiUrlV2 = document.location.protocol + '//' + document.location.host + '/api-v2/';
        this.version = document.getElementById("buildjs")['src'].match(/dist\/(\d+)\/main\.js/)[1];
        this.baseUrl = document.location.protocol + '//' + document.location.host;
        this.wsUrl = `ws.${window.location.hostname.replace(/api\./, '')}:${window.location.port}`;
        // this.wsUrl = `http://localhost:8050/`; // local development

        this.barcodeBaseUrl = 'https://devbarcode.codereadr.com';
        if (document.location.host.startsWith("secure.codereadr.com")) {
            this.barcodeBaseUrl = 'https://barcode.codereadr.com';
        }
    }
}

export default new Config();